// extracted by mini-css-extract-plugin
export default {"containerCard":"InformationsTab_containerCard__HfLmR","sectionTitle":"InformationsTab_sectionTitle__zaDN7"};